import { Skeleton } from '@mui/material';

export type BlockSkeletonProps = {
  width?: string;
  height: string;
};

export function BlockSkeleton({ width = '100%', height }: BlockSkeletonProps) {
  return (
    <Skeleton
      variant="rectangular"
      animation={false}
      width={width}
      height={height}
      sx={{ borderRadius: '12px', background: '#F9FAFB' }}
    />
  );
}
